<template>
  <ul>
    <li v-for="(value, key) in object" :key="key">
      <strong v-if="value.questionValue">{{ value.questionValue }}:</strong>
      <template v-if="isObject(value)">
        <nested-answer-display :object="value" />
      </template>
      <template v-else>
        {{ value.answerValue }}
      </template>
    </li>
  </ul>
</template>
  
<script>
export default {
  name: "nested-answer-display",
  props: {
    object: {
      type: [Array, Object],
    },
  },
  methods: {
    isArray(value) {
      return Array.isArray(value);
    },
    isObject(value) {
      // special case for the final display object to show the question and answer values
      const keys = Object.keys(value);
      if (
        keys.length === 2 &&
        keys.includes("questionValue") &&
        keys.includes("questionValue")
      )
        return false;

      return typeof value === "object";
    },
  },
};
</script>
  
<style lang="scss" scoped>
ul {
  padding-left: 0;
  li {
    list-style: none;
    & > ul {
      padding-left: $qvo-spacing-16;
    }
  }
}
</style>